import { createContext } from 'use-context-selector';
import { DashboardState } from './types';
import { defaultDashboardState } from './defaultState';

const DashboardContext = createContext<Partial<DashboardState>>(defaultDashboardState);

export { DashboardContext };
